<template>
  <div class="resourcePool">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">资源池</div>
        </div>
      </div>
    </div>
    <!-- 服务商分类+服务分类+专家数 -->
    <div class="serviceCon">
      <div v-for="(item, index) in serviceInfo" :key="index" class="serviceItem">
        <div class="serviceItem-bg" :style="{ backgroundImage: `url(${item.icon})` }"></div>
        <div class="serviceItem-con">
          <div class="serviceItem-con-num">
            {{ item.num
            }}
            <span style="font-size:15px;color:#000;margin-left:2px">个</span>
          </div>
          <div class="serviceItem-con-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 细分领域服务商排行 + 服务能力 -->
    <rankAndAbility></rankAndAbility>
    <!-- 服务商 -->
    <serviceProvider></serviceProvider>
    <!-- 众多优质服务商提供数字化转型服务 -->
    <!-- <div class="transformService">
      <div class="box-title">众多优质服务商提供数字化转型服务</div>
      <div class="serviceBg-box">
        <div v-for="(item, index) in serviceList" :key="index" class="serviceItem"
          :style="{ backgroundImage: `url(${item.avatar})` }" @click="serviceDetail(item.uuid)"></div>
    </div>-->
    <div
      class="service-btn curp"
      @click="onClickProviderMore"
      style="margin: 0 auto;width: 100px;text-align: center;margin-bottom: 20px;"
    >查看更多</div>
    <!-- </div> -->
    <!-- 专家库 -->
    <div class="experts">
      <div class="experts-con">
        <div class="experts-con-title">
          专家库
          <!--          <span class="experts-con-num">（{{ num }}）</span>-->
        </div>
        <div class="experts-con-profile">{{ profile }}</div>
      </div>
    </div>
    <!-- 擅长领域 -->
    <greatField id="field" :title="title"></greatField>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getCount,
  getServiceSortCount,
  getServiceCount,
  getServiceIcon
} from "../../utils/interface";
import rankAndAbility from "./rankAndAbility";
import serviceProvider from "./serviceProvider";
import greatField from "./greatField";
export default {
  name: "",
  components: { rankAndAbility, serviceProvider, greatField },
  props: {},
  data() {
    return {
      headerBgUrl: "",
      serviceInfo: [
        {
          icon: require("../../assets/publicService/resourcePool/10.png"),
          name: "服务商总数",
          num: " "
        },
        {
          icon: require("../../assets/publicService/resourcePool/11.png"),
          name: "服务分类",
          num: " "
        },
        {
          icon: require("../../assets/publicService/resourcePool/12.png"),
          name: "专家数",
          num: " "
        }
      ],
      serviceList: [
        // { avatar: require('../../assets/publicService/resourcePool/21.png') },
        // { avatar: require('../../assets/publicService/resourcePool/22.png') },
        // { avatar: require('../../assets/publicService/resourcePool/23.png') }
      ],
      num: 168,
      profile:
        "汇聚一批不同行业、领域资深专家，充分发挥专家队伍的优势，为我区数字化\n" +
        "转型工作提供智力支持和技术保障，为政策制定、评估诊断、专项培训、供需\n" +
        "对接提供专业支撑，进一步促进我区新型工业化纵深发展",
      title: "",
      timer: null
    };
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  created() {
    this.getOptionsData();
    this.getServiceCount(); // 获取服务商数量
    this.getServiceSortCount(); // 获取服务分类
    this.getCount(); // 获取专家个数
    this.getServiceIcon(); // 获取服务商图标信息
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 获取专家个数
    getCount() {
      getCount().then(res => {
        if (res) {
          this.serviceInfo[2].num = this.num = res;
        } else {
          this.serviceInfo[2].num = this.num = "";
        }
      });
    },
    // 获取服务分类
    getServiceSortCount() {
      getServiceSortCount().then(res => {
        if (res) {
          this.serviceInfo[1].num = res;
        } else {
          this.serviceInfo[1].num = "";
        }
      });
    },
    // 获取服务商数量
    getServiceCount() {
      getServiceCount().then(res => {
        if (res) {
          this.serviceInfo[0].num = res;
        } else {
          this.serviceInfo[0].num = "";
        }
      });
    },
    // 获取服务商图标信息
    getServiceIcon() {
      getServiceIcon({
        status: 1,
        rec: 1,
        programUuid: ""
      }).then(res => {
        if (res && res.length > 0) {
          this.serviceList = res;
        } else {
          this.serviceList = [];
        }
      });
    },
    onClickLookMore() {},

    //众多优质服务商-查看更多
    onClickProviderMore() {
      let route = this.$router.resolve({
        path: "/providerList"
      });
      window.open(route.href, "_blank");
    },
    // 获取服务商详情
    serviceDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.resourcePool {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 20px;
        // background-color: white;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 104px;
        transition: all 0.2s;
      }
    }
  }

  .serviceCon {
    width: 1300px;
    height: 96px;
    margin: 0 auto;
    background-color: #fff;
    position: relative;
    top: -66px;
    border-radius: 8px;
    box-shadow: 0 0 8px #99999947;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .serviceItem {
      width: 420px;
      height: auto;
      border-right: 1px solid #d5dcec;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      &:last-child {
        border-right: none;
      }

      .serviceItem-bg {
        width: 60px;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .serviceItem-con {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        margin-left: 20px;

        .serviceItem-con-num {
          color: #2d50a1;
          font-size: 30px;
          font-weight: 600;
        }

        .serviceItem-con-name {
          font-size: 17px;
          font-weight: 600;
        }
      }
    }
  }

  .box-title {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    padding: 10px 0 15px;
  }

  .transformService {
    .serviceBg-box {
      width: 1300px;
      // height: 320px;
      min-height: 150px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: stretch;

      .serviceItem {
        width: 165px;
        height: 75px;
        // box-shadow: 0 0 8px #99999947;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        transition: all 0.2;
        margin: 5px;

        &:hover {
          transform: scale(1.05);
          cursor: pointer;
        }
      }
    }

    .service-btn {
      width: 135px;
      height: 34px;
      margin: 0 auto;
      margin-top: 10px;
      font-size: 14px;
      color: #fff;
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;
      line-height: 34px;
      margin-bottom: 20px;
      background-color: #2d50a1;
      cursor: pointer;
    }
  }

  .experts {
    height: 295px;
    background: url("../../assets/publicService/resourcePool/5.png") no-repeat
      center center/100% 100%;

    .experts-con {
      width: 1300px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;

      .experts-con-title {
        font-size: 28px;
        font-weight: 600;

        .experts-con-num {
          font-size: 22px;
          color: #2d50a1;
        }
      }

      .experts-con-profile {
        white-space: pre-wrap;
        margin-top: 15px;
        line-height: 2;
        font-weight: 500;
      }
    }
  }
}

/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/index.vue